import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import {
  REFRESH_TOKEN,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_ERROR,
  LOGOUT,
  SET_TOKEN,
  REFRESH_TOKEN_EXPIRATION_CHECK
} from '../types/auth';
import services from '../../services';
import { checkTokenExpiration, jwtDecode, tokenExpirationTimePart } from '../../helpers/token-utils';

function* refreshToken({ payload }) {
  try {
    const {response, error} = yield call(services.auth.refreshToken, payload.token );
    if (error) {
        yield put({ type: REFRESH_TOKEN_ERROR, payload: error });
    } else {
        if (payload.callback) {
          yield call(payload.callback);
        }
        yield put({
            type: REFRESH_TOKEN_SUCCESS,
            payload: response,
        });
    }
  } catch (error) {
    yield put({
        type: REFRESH_TOKEN_ERROR,
        payload: "Error de REFRESH",
    });
    logout();
  }
}

function* setToken() {
  const token = services.auth.getToken();
  if(token) {
    const {exp} = jwtDecode (token);
    yield put({
      type: REFRESH_TOKEN_SUCCESS,
      payload: {token, exp},
    });
  } else {
    yield put({
      type: REFRESH_TOKEN_ERROR,
      payload: "Error de REFRESH",
    });
    logout();
  }
}

function* logout() {
  services.auth.signOut();
  yield put(logout());
}

function* checkTokenExpirationSagas() {
  while (true) {
    const token =localStorage.getItem('token');
    const exp = sessionStorage.getItem('exp');
    yield put({
      type: REFRESH_TOKEN_SUCCESS,
      payload: {token, exp },
  });
    yield delay(tokenExpirationTimePart());
    const tokenExpirationTime = checkTokenExpiration();
    if (token && tokenExpirationTime) {
      yield call(refreshToken, {payload: {token}});
    }
  }
}

export default function* authSaga() {
  yield takeLatest<any>(REFRESH_TOKEN, refreshToken);
  yield takeLatest<any>(LOGOUT, logout);
  yield takeLatest<any>(SET_TOKEN, setToken);
  yield takeLatest<any>(REFRESH_TOKEN_EXPIRATION_CHECK, checkTokenExpirationSagas);
}